module.exports = __webpack_public_path__ + "static/media/CSK-horiz-mobile-hover@2x.9a9d6dec.png";